/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Aymara2Inputs */

const en__field__enum_nativelanguage_aymara2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Aymara2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aymara`)
};

const de__field__enum_nativelanguage_aymara2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Aymara2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aymara`)
};

/**
* | output |
* | --- |
* | "Aymara" |
*
* @param {_Field__Enum_Nativelanguage_Aymara2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_aymara2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Aymara2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Aymara2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_aymara2(inputs)
	return de__field__enum_nativelanguage_aymara2(inputs)
});
export { _field__enum_nativelanguage_aymara2 as "_field__enum_nativeLanguage_Aymara" }